require('./automatic-backlink.scss');
if(document.referrer.indexOf(HOST)>-1 && document.location.hash.indexOf('#backlink:')===0)
{
    $('a[data-automatic-backlink="true"]').attr('href',document.referrer.replace(/#.*/,'')+'#'+document.location.hash.replace('#backlink:',''));
    $('a[data-automatic-backlink="true"]').show();

    $('a[href="#jsBacklink"]').attr('href',document.referrer.replace(/#.*/,'')+'#'+document.location.hash.replace('#backlink:',''));
    $('a[href="#jsBacklink"]').show();
}
else
{
	$('a[href="#jsBacklink"]').hide();
}